import { Observable, tap } from 'rxjs';

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';

import { UserManagementService } from '../../services/user-management.service';
import { AuthenticationService } from '../../services/authentication.service';
import { UserInfo } from '../models/user-info.model';

@Injectable({
  providedIn: 'root',
})
export class AppLevelInfoResolver implements Resolve<UserInfo> {
  constructor(
    private authenticationService: AuthenticationService,
    private userManagementService: UserManagementService,
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<UserInfo> {
    return this.authenticationService.getCurrentUser().pipe(
      tap((userInfo) => {
        this.userManagementService.addUserInfo(userInfo);
      }),
    );
  }
}
